import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './assets/style.css';
import { clearStorage } from 'utils/storage';

const UnAuthorized = () => {
  const currentYear = new Date().getFullYear();
  const backToLogin = () => {
    setTimeout(() => {
      clearStorage();
      window.location.assign('/auth/login');
    }, 1000);
  };

  return (
    <div className='h-screen flex-col flex'>
      <div className='flex md:flex flex-1 items-center justify-center'>
        <div className={`space-x-1 flex items-center`}>
          <img className='h-16 w-auto' src='/XPayNL.svg' alt='Workflow' />
        </div>
      </div>
      <div className='flex-1 flex flex-col items-center space-y-2'>
        <ExclamationCircleOutlined className='auth_sign' style={{ color: 'red' }} />
        <div className='max-w-md w-full space-y-8'>
          <div className='mt-4 text-center space-y-2'>
            <h2 className='text-xl md:text-3xl font-extrabold text-gray-900'>{'Access Denied'}</h2>
            <p className='text-xs'>{'Oops! Account inactive temporarily. No worries! Please contact XPay support team to reactivate your account.'}</p>
          </div>
          <p className='text-xs text-center'>
            <a href='https://xpay.postexglobal.com' target='_blank' rel='noopener noreferrer' className='text-black hover:text-black'>
              {' '}
              ©{currentYear} PostEx.
            </a>
          </p>
          <button
            className='backButton'
            onClick={() => {
              backToLogin();
            }}>
            Back to Login?
          </button>
        </div>
      </div>
    </div>
  );
};
export default UnAuthorized;
